import { createFileRoute } from "@tanstack/react-router";
import { ForgotPassword } from "./glomt-losenord";

const TITLE = "Olvidé mi contraseña — Sellavo";
const DESCRIPTION = "Restablece la contraseña de tu cuenta de Sellavo con un enlace por correo.";

export const Route = createFileRoute("/es/olvide-contrasena")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ForgotPassword,
});
